import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'digitShort'
})
export class DigitPipe implements PipeTransform {
  transform(value) {
    if (value != null) {
      const rounded = Math.round(value * 100) / 100;
      if (rounded > 0) {
        let x = rounded.toFixed(0);

        x = x.toString();

        const y = Math.floor(parseFloat(x)) + '';
        let lastThree = y.substring(y.length - 3);
        const otherNumbers = y.substring(0, y.length - 3);
        if (otherNumbers !== '') {
          lastThree = ',' + lastThree;
        }
        let finalNumber: string = (
          otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') +
          lastThree
        );
        switch (finalNumber.split(",").length) {
          case 1: return finalNumber;
          case 2: return finalNumber.split(",")[0] + " K";
          case 3: return finalNumber.split(",")[0] + " L";
          case 4: return finalNumber.split(",")[0] + " Cr";
          case 5: return finalNumber.split(",")[0] + "," + finalNumber.split(",")[1] + " Cr";
        }

      } else {
        return rounded.toFixed(0);
      }

      // return parseFloat(rounded.toFixed(1))
    } else {
      return "0";
    }
  }
}
